import React, { Component } from 'react';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import ArtistListItem from 'components/ArtistList/ArtistListItem';

class ArtistList extends Component {

  render() {
    if (!this.props.artists) {
      return <Typography>Loading</Typography>;
    }
    if (this.props.artists.length > 0) {
      return (
        <Grid container spacing={2}>
          {this.props.artists.map((artist) => <ArtistListItem key={artist.pageid} artist={artist} cols={this.props.cols} />)}
        </Grid>
      )
    } else {
      return <Typography>No Results</Typography>;
    }
  }
}

export default ArtistList;